/* eslint-disable menti-react/filename-convention--jsx */
import { explore } from '@mentimeter/sfinx-themes';
import { useOptionalPace } from '../../data-mediation';

const C = explore.background;

export const ExploreBackground = () => {
  const progress = useOptionalPace()?.selectors?.progress() ?? 0;
  return <C progress={progress} />;
};
